import React, { Component, useLayoutEffect, useState } from "react";
import Swal from "sweetalert2";
import { messaging } from './firebase';
import { getToken } from "firebase/messaging";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption, getLocalStorageKey } from "./common/common";
// import ajaxProxy from '../globs/ajax-proxy';
// import environmentVariables from '../globs/utils/get-environment-variables';

const requestForToken = (id) => {
    localStorage.setItem("notificationPermission", "true");
    return getToken(messaging, { vapidKey: 'BMK-NiKj6Y2IOf_978lpH4syE8Evfqi0T9Uzj_RUzJ9DGskkE8tlQe6nDOtSJcQduHdsXjwT57tPmq9QhbD0F-c' })
      .then((currentToken) => {
        if (currentToken) {
          console.log('current token for client: ', currentToken);
          // Perform any other neccessary action with the token
          sendFcmTokenToBackend(id,currentToken)
        } else {
          // Show permission request UI
          console.log('No registration token available. Request permission to generate one.');
        }
      })
      .catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      });
};

const sendFcmTokenToBackend = (id,currentToken) => {
    // const id = getLocalStorageKey("id");
    let dataToSend = {
        subscription: currentToken,
        device_type: "adminPanel"
    };

    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "POST";
    options.body = JSON.stringify(dataToSend);
    fetch(`${apiUrl}/admin_panel_users/${id}/push_subscriptions`, options)
        .then((res) => {
        if (res.ok) return res.json();
        return res.json().then(res => {
            throw new Error(res.errors.status)
        })
    })
    .then((json) => {
        if (json) {
            console.log("json reply", json);
        }
    }).catch((error) => {
        console.log(error);
    });
}



async function getNotificationPermission(id,notificationText= "You have enabled notification") {
    console.log('abcd in the getNotificationPermission');
    if (!("Notification" in window)) {
        Swal.fire("Browser does not supports notification", "", "info");
    } else if(Notification.permission === "granted") {
        // const notificationOptions = {
        //     body: notificationText,
        //     sound: 'default',
        //     icon : 'https://homepages.cae.wisc.edu/~ece533/images/zelda.png'
            
        //   };
        // const notification = new Notification(notificationText,notificationOptions);
        requestForToken(id);
        let title = notificationText;
        const notification = new Notification(title, {
            body: 'This is the body of the notification',
            icon: './images/navender_logo.png', // Path to the icon image
            data: { url: 'http://localhost:3000/sap_digital_app_orders/' },  // Custom data, if needed
            sound: 'default',
          });

          notification.onclick = (event) => {
            // event.preventDefault(); // prevent the browser from focusing the Notification's tab
            window.open(notification.data.url,"_blank");
          };
    } else if(Notification.permission !== "denied"){
        Notification.requestPermission().then((permission)=>{
            if (permission === 'granted') {
                requestForToken(id);
                // const notification = new Notification({title:notificationText,body:notificationText});
                let title = notificationText;
                const notification = new Notification(title, {
                    body: 'This is the body of the notification',
                    icon: './images/navender_logo.png', // Path to the icon image
                    data: { url: 'http://localhost:3000/sap_digital_app_orders/' }, // Custom data, if needed
                    sound: 'default',
                  });
        
                  notification.onclick = (event) => {
                    // event.preventDefault(); // prevent the browser from focusing the Notification's tab
                    window.open(notification.data.url,"_blank");
                  };
            }
        })

    }
}



// function webPushSendSubscription(user) {
//   return (dispatch) => {
//     navigator.serviceWorker.ready.then(
//       (serviceWorkerRegistration) => {
//         serviceWorkerRegistration.pushManager.subscribe(
//           {
//             userVisibleOnly: true,
//             applicationServerKey:
//               urlBase64ToUint8Array(environmentVariables.REACT_APP_RUNTIME_VAPID_PUBLIC_KEY),
//           })
//           .then((subscription) => {
//             ajaxProxy.webPushSubscribe({
//               subscription,
//               targetUrl: user._links.push_subscriptions.href,
//             }).then(() => {
//               dispatch(setIsSubscribed(true));
//             });
//           })
//           .catch(() => {
//             // eslint-disable-next-line
//             console.error('Not able to subscribe');
//             dispatch(setIsSubscribed(false));
//           });
//       });
//   };
// }

/* eslint-disable */
function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/')
  ;
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}
/* eslint-disable */

export { getNotificationPermission ,urlBase64ToUint8Array }
